import { useTranslation } from 'react-i18next';
import { BombiixModal } from '../../Components/BombiixModal';

interface DeintegrateSupplierProps<TIndex> {
  show: boolean;
  handleClose: () => void;
  handleConfirm: (index: TIndex | undefined) => void;
  index?: TIndex;
}

/**
 * Confirms de-integrating a supplier in the master-design modal chrome; the note
 * the old dialog carried sits under the question.
 * @param {object} props - Component props.
 * @param {boolean} props.show - Whether the confirm is open.
 * @param {Function} props.handleClose - Closes without de-integrating.
 * @param {Function} props.handleConfirm - Called with `index` on confirm.
 * @param {*} props.index - Identifies the supplier being de-integrated.
 * @returns {React.ReactElement} The confirmation modal.
 */
function DeintegrateSupplier<TIndex>({ show, handleClose, handleConfirm, index }: DeintegrateSupplierProps<TIndex>) {
  const { t } = useTranslation('common');

  return (
    <BombiixModal
      show={show}
      size="sm"
      title={t('DEINTEGRATE_SUPPLIER.DEINTEGRATE_SUPPLIER_TITLE')}
      onClose={handleClose}
      onSave={() => handleConfirm(index)}
      saveLabel={t('DEINTEGRATE_SUPPLIER.DEINTEGRATE_SUPPLIER_YES')}
      saveVariant="red"
    >
      <div className="bombiix-modal__confirm-body">
        <p className="mb-0 text-center">{t('DEINTEGRATE_SUPPLIER.DEINTEGRATE_SUPPLIER_CONFIRMATION')}</p>
        <p className="mb-0 text-center">{t('DEINTEGRATE_SUPPLIER.DEINTEGRATE_SUPPLIER_NOTE')}</p>
      </div>
    </BombiixModal>
  );
}

export default DeintegrateSupplier;
